import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  meta: {
    pageNumber: 1,
    pageSize: 20,
    itemTotal: 0,
  },
  list: [],
  reports: [],
  selectedFee: {},
  feeAdded: false,
  feeUpdated: false,
  feeRemoved: false,
};

const proposalFeeSlice = createSlice({
  name: "proposalFee",
  initialState,
  reducers: {
    getProposalFees(state, action) {
      state.list = action.payload.fees;
      state.meta = action.payload.meta;
    },
    getProposalFeeById(state, action) {
      state.selectedFee = action.payload;
    },
    addFeeProposal(state, action) {
      state.feeAdded = true;
    },
    updateFeeProposal(state, action) {
      state.feeUpdated = true;
    },
    removeFeeProposal(state, action) {
      state.feeRemoved = true;
    },
    reset: (state) => initialState,
    logout: (state) => initialState,
  },
});

export const proposalFeeActions = proposalFeeSlice.actions;
export default proposalFeeSlice;
